module.exports = __webpack_public_path__ + "static/media/BertrandCullier.8f838d9d.jpg";